// pts for predicting the correct outcome AND score
export const CORRECTRESULTSCORES = 8;

// pts for predicting the correct outcome but not the score
export const CORRECTRESULT = 3;

// From this day onwards, no more updates to predictions
export const CLOSUREDATE = new Date("2026-07-02T00:00:00Z");
//export const CLOSUREDATE = new Date("2025-01-01T00:00:00Z");

// pts for predicting the correct outcome in the final8 stage
export const CORRECTFINAL8 = 7;
export const CORRECTFINAL8TEAM = 5;

// pts for predicting the correct outcome in the final4 stage
export const CORRECTFINAL4 = 9;
export const CORRECTFINAL4TEAM = 7;
// pts for predicting the correct outcome in the final stage
export const CORRECTFINAL = 12;
export const CORRECTFINALTEAM = 11;

// pts for predicting the correct outcome in the questionnaire stage
export const CORRECTQUESTIONNAIRE = 12;